import type { CurriculumApi } from '@mathflat/domain/@entities/Curriculum/api'
import { makeAutoObservable } from 'mobx'

import { curriculumApi } from '~/@common/api/curriculumApi'

export class ChapterSearchService {
  chapterList: CurriculumApi.Response.ChaptersBySearch['chapters'] | null = null

  constructor() {
    makeAutoObservable(this)
  }

  resetChapterList = () => {
    this.chapterList = null
  }

  fetchChapterList = async (trieKey: string, search: string) => {
    const { chapters } = await curriculumApi.getCurriculumChaptersBySearch(trieKey, search)
    this.chapterList = chapters
  }
}
